import '/src/TheApp.js';
import '@/assets/css/vars/colors.css';
import '@/assets/css/global.css';
import { profileStore } from './src/stores/profile.js';
import { initRouting } from './src/router/index.js';
import { h, Fragment } from './src/utils/render.js';
import { httpClient } from "@/services/HttpClient";
import { connectionStatus } from "@/services/ConnectionStatus";
window.h = h;
window.Fragment = Fragment;
function createApp() {
    const $app = document.createElement('the-app');
    document.querySelector('#app').append($app);
}
async function initApp() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js')
                .then(() => console.log('PWA воркер готов!'))
                .catch((err) => console.error('Ошибка воркера:', err));
        });
    }
    httpClient.onFetchError(({ args }) => {
        const url = args[0];
        if (url === connectionStatus.connectionStatusEndpointURL) {
            connectionStatus.checkStatus();
        }
    });
    createApp();
}
initApp();
